import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import OtherUserGroupTypeModel from "@/commons/models/OtherUserGroupType";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 利用者 API 操作クラス
 */
export default class OtherUserGroupTypes {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET OtherUserGroupTypes
   */
  public async get(userStore: LoginUser): Promise<Array<OtherUserGroupTypeModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OtherUserGroupTypes, formatParams);
    const response = await this.commonService.executeGet<Array<OtherUserGroupTypeModel>>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * PATCH OtherUserGroup
   */
  public async patch(userStore: LoginUser, requestBody: OtherUserGroupTypesPatchModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OtherUserGroupTypes, formatParams);
    const response = await this.commonService.executePatch<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface OtherUserGroupTypesPatchModel {
  /** グループアイテム */
  otherUserGroupTypes: Array<OtherUserGroupTypesItem>;
  /** 更新日時 */
  updated: number;
}

export interface OtherUserGroupTypesItem {
  /** ID */
  id: number;
  /** グループ種類名 */
  name: string;
  /** グループ種類説明 */
  description: string;
}
